export default __webpack_public_path__ + "static/media/promo_official.7c1ed6dc.svg";